import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import classes from "./SearchBar.module.scss";
import Icon, { NAMES, SIZES } from "../../../../atoms/Icon";

const SearchBar = ({ placeholder, value, onChange, onSearch, className }) => {
  const handleSearch = () => {
    if (onSearch) {
      onSearch(value);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className={cs(classes.searchContainer, className)}>
      {/* Search Icon - Left Side */}
      <div className={cs(classes.searchIconWrapper)}>
        <Icon
          name={NAMES.SearchIcon}
          size={SIZES.L}
        />
      </div>

      <div className={cs(classes.searchInputWrapper)}>

        {/* Input Field */}
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          className={cs(classes.searchInput, "grandstanderFamily")}
        />
      </div>

      {/* Arrow Button - Right Side */}
      <button
        type="button"
        onClick={handleSearch}
        className={cs(classes.searchButton)}
        aria-label="Search"
      >
        <Icon
          name={NAMES.ArrowIcon}
        />      
        </button>
    </div>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  className: PropTypes.string,
};

SearchBar.defaultProps = {
  placeholder: "Search Name",
  className: "",
  onSearch: null,
};

export default SearchBar;